// plugins/breadcrumbs.ts
export default defineNuxtPlugin({
  name: "breadcrumbs",
  dependsOn: ["translator"],
  parallel: true,
  setup(app) {
    app.hook("page:finish", () => {
      const { generateBreadcrumbs, setBreadcrumbs } = useBreadcrumbs();

      const route = useRoute();

      // Custom breadcrumb logic for specific routes
      const customBreadcrumbs: Record<string, () => BreadcrumbItem[]> = {
        // Add more custom routes as needed
      };

      // Check if there's a custom breadcrumb for the current route
      const customHandler = customBreadcrumbs[route.path] || customBreadcrumbs[route.matched[0]?.path];

      if (customHandler) {
        setBreadcrumbs(customHandler());
      } else {
        // Fallback to generated breadcrumbs
        setBreadcrumbs(generateBreadcrumbs(route));
      }
    });
  },
});
